<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10
        0C15.5228 0 20 4.47715 20 10ZM10 18.5093C14.6996 18.5093 18.5093 14.6996 18.5093 10C18.5093
        5.30043 14.6996 1.49068 10 1.49068C5.30043 1.49068 1.49068 5.30043 1.49068 10C1.49068
        14.6996 5.30043 18.5093 10 18.5093Z"
      fill="#EAB308"
    />
    <path
      d="M11.3336 3.19275H9.40625V14.3438H11.3336V3.19275Z"
      fill="#EAB308"
    />
    <path
      d="M14.4427 7.98776C14.0229 6.2397 12.4401 4.91353 10.5757
        4.91353H6.59193V9.34328H8.41971V6.74229H10.5775C11.7471 6.74229 12.7353 7.7328 12.7353
        8.90122C12.7353 10.0715 11.7471 11.0602 10.5775
        11.0602H6.59193V14.7177H6.58398V16.5465H8.41971V12.8889H10.5775C12.4419 12.8889 14.0351
        11.5627 14.4549 9.81469C14.5228 9.52275 14.5343 9.21852 14.5343 8.90589C14.5343 8.58993
        14.5121 8.28254 14.4427 7.98776Z"
      fill="#EAB308"
    />
  </svg>
</template>
<script>
export default {
  name: 'PrataCoin',
};
</script>
